import { Component, inject } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { EnaioLearnService } from '../../services/enaio-learn.service';
import { LearningContentParticipantDto } from '../../shared/learning-content-participant.dto';
import { LearningContent } from '../../shared/learning-content.entity';
import { JobDescription } from '../../shared/job-description.entity';

@Component({
    selector: 'app-analyses-participations',
    templateUrl: './analyses-participations.component.html',
    styleUrls: ['./analyses-participations.component.scss']
})
export class AnalysesParticipationsComponent extends ComponentView {

    service = inject(EnaioLearnService);

    contents: SelectItem[];
    selectedContent: number = null;

    data: LearningContentParticipantDto[];
    table: TableData;

    jobDescriptions: SelectItem[];
    selectedJobDescriptions: string[];

    async initParams(): Promise<boolean> {
        this.service.updateNavigation(null, [
            { label: this.app.t("lea.analyses.title"), routerLink: ["/enaio-learn", "analyses"] },
            { label: this.app.t("lea.analyses.participations.title"), routerLink: ["/enaio-learn", "analyses", "participations"] }
        ]);
        this.contents = [ { value: null, label: "<Alle>" }, ...Utils.arraySortBy((await RestEndpoint.main().find().run("api/lrn/learningcontent").list(LearningContent)).map(c => ({ value: c.id, label: c.title })), si => si.label)];
        this.jobDescriptions = Utils.arraySortBy([{ value: "", label: "<Ohne>" }, ...Utils.arrayGetUnique((await RestEndpoint.main().find().run("api/lrn/jobdescription").list(JobDescription)).map(jd => jd.group)).map(c => ({ value: c, label: c }))], si => si.label);
        this.selectedJobDescriptions = this.jobDescriptions.map(jd => jd.value);

        await this.updateFilter(true);
        return true;
    }

    async updateFilter(rest: boolean): Promise<void> {
        if (rest) {
            this.data = await RestEndpoint.main().query(Utils.objectRemoveNullValues({ open: false, closed: true, learningContentId: this.selectedContent })).run("api/lrn/learningcontent/analysesParticipants").list(LearningContentParticipantDto);
        }

        this.table = new TableData([
            new TableColumn("learningContentTitle", "Lerninhalt", TableCellType.text, { autoWidth: 30 }),
            new TableColumn("userName", "Person", TableCellType.text, { autoWidth: 30 }),
            new TableColumn("department", "Einrichtung", TableCellType.text, { autoWidth: 30 }),
            new TableColumn("jobDescription", "Dienstart", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("mandatory", "Pflichtinhalt", TableCellType.yesNo, { autoWidth: 1 }),
            new TableColumn("endDate", "Datum", TableCellType.date, { autoWidth: 1 }),
            new TableColumn("exposureTime", "Anrechenbare Zeit", TableCellType.int, { autoWidth: 4 }),
            new TableColumn("doneDuringOfficeHours", "Während der Arbeitszeit", TableCellType.yesNo, { autoWidth: 1 })
        ], this.data.filter(p => this.selectedJobDescriptions.includes(p.jobDescription)).map(p => new TableRow("", p, {
            learningContentTitle: p.learningContentTitle,
            userName: p.userName,
            department: p.department,
            jobDescription: p.jobDescription,
            mandatory: p.mandatory,
            endDate: p.finishedDate,
            exposureTime: p.exposureTime,
            doneDuringOfficeHours: p.doneDuringOfficeHours
        })), [new TableSortColumn("endDate", false), new TableSortColumn("learningContentTitle"), new TableSortColumn("userName")]);
    }

}
